export default __webpack_public_path__ + "static/media/fullscreen-enter.47fab6db.svg";